import { useCallback, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  Stack,
  Typography,
  Avatar,
  Unstable_Grid2 as Grid,
  
} from '@mui/material';
import React, {useEffect,useRef} from "react";
import CustomDialog from '../../components/Modals/ProfileModal/ProfileModal'
import CardMedia from '@mui/material/CardMedia';
import assessmentsImage from './BackgroundProfile.png'
import Iconify from '../../common/Iconify/Iconify';
import FormRequestKeys from './FormToRequestKeys';
import {BASE_URL} from "../../baseUrl"



export const AccountProfileDetails = ({ fullname,email, category, city, country, signatory, datesigned, bio, photo_url,id_user,token,email_conf,account_number, handlereload}) => {
  
  const [values, setValues] = useState({
    fullname:fullname,
    email: email,
    category: category,
    city: city,
    country: country,
    signatory: signatory,
    datesigned: datesigned,
    bio: bio,
    photo_url: photo_url,
    id_user: id_user,
    token: token,
    email_conf: email_conf,
    account_number : account_number

  });

  const handleChange = useCallback(
    (event) => {
      setValues((prevState) => ({
        ...prevState,
        [event.target.name]: event.target.value
      }));
    },
    []
  );

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();
    },
    []
  );

  const [open, setOpen] = useState(false);
  const [dialogType, setDialogType] = useState(1)

  const handleClickOpen = (type) => {
    console.log("Opening dialog with type:", type)
    setDialogType(type);
    setOpen(true);
  };

  useEffect(() => {
    setValues({
      fullname,
      email,
      category,
      city,
      country,
      signatory,
      datesigned,
      bio,
      photo_url,
      id_user,
      token,
      email_conf,
      account_number
    });
  }, [fullname, email, category, city, country, signatory, datesigned,bio,photo_url,id_user,token,email_conf,account_number]);

  const handleClose = () => {
    setOpen(false);
    handlereload()
  };

  // Create a ref for the hidden file input
  const fileInputRef = useRef(null);

  // Function to trigger file input click
  const handleEditPictureClick = () => {
    fileInputRef.current.click();
  };

  // Function to handle file selection
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
  
    // Prepare the form data
    const formData = new FormData();
    formData.append('file', file);
  
    try {
      // Replace 'your-api-endpoint' with the actual endpoint where you handle the file upload
      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
            Authorization: "Bearer " + token,
        },
      };
      
      const response = await fetch(BASE_URL + `/api/user/profile/photo/${id_user}`, requestOptions);
  
      const result = await response.json();
  
      if (response.ok) {
        console.log('Upload successful', result);
        // Optionally, update your UI to reflect the uploaded photo
      } else {
        console.error('Upload failed', result.detail);
        // Handle errors, maybe show a message to the user
      }
    } catch (error) {
      console.error('Error uploading the file', error);
      // Handle network errors, maybe show a message to the user
    }
  };

  return (
          
    <form
      autoComplete="off"
      noValidate
      onSubmit={handleSubmit}
    >
      <Stack spacing={5} 
                     sx={{
                      '& .MuiPaper-root': {
                      backgroundColor: '#231E39',
                                    
                      },}}
      >
        <Card>
          <CardMedia
            sx={{ height: 250 }}
            
            image={assessmentsImage}
            title="background"
          />
            <Box
              sx={{
                
                backgroundColor: '#FEBB0B',
                borderRadius: '3px',
                fontSize: '11px',
                fontWeight: 'bold',
                position: 'relative',
                top: '57px',
                left: '35%',
                marginBottom: '20px', // Adjust margin as needed
                zIndex: '2',
                maxWidth: '100px',
                textAlign: 'center'
                  }}
            >
              {values.category === "Developer" ? "Developer" : 
              values.category === "Signatory" ? "Signatory" :
              "Non-signatory"}
            </Box>
          <CardContent>
            <Box
              sx={{alignItems: 'center',display: 'flex',flexDirection: 'column'}}
            >
            <Box
              sx={{
                width: 150,
                height: 150,
                borderRadius: '50%',
                overflow: 'hidden',
                border: '1px solid var(--main-color)',
                zIndex: '1',
                marginBottom: '20px'
              }}
            >
              <img
                src={values.photo_url}
                alt="Profile"
                style={{
                  width: '100%', // Make the image fill the entire circular border
                  height: '100%', // Make the image fill the entire circular border
                  objectFit: 'cover',
                }}
              />
            </Box>


              <Typography gutterBottom variant="h3" color="white">
                {values.fullname}
              </Typography>
              <Typography gutterBottom variant='h5' color="whitesmoke">
                {values.city}
              </Typography>
              <Typography gutterBottom variant='h6' color="whitesmoke">
                {values.country}
              </Typography>


              <Typography  sx={{ color: 'gray', fontSize: '11px'}} >
                {values.bio}
                <Iconify
                icon="mdi:book-edit-outline"
                style={{cursor: 'pointer', }}
                onClick={() => handleClickOpen(0)}
                />
              </Typography>

              
            </Box>
            
          </CardContent>
          
          <Divider />
          
          {/* Hidden file input */}
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: 'none' }}
            accept="image/*"  // Accept images only
          />

          <CardActions
                   sx={{
                    '& .MuiButton-text' : {color: 'var(--main-color)'},
                    '& .MuiButtonBase-root' : {border: '1px solid var(--main-color)'},
                  }} 
          >
            <Button fullWidth onClick={handleEditPictureClick}>
              Edit profile picture
            </Button>

          </CardActions>
        </Card>

        <Card>
          <CardHeader
            subheader="Review your profile information and update if needed"
            title="Profile"
            sx={{
              '& .MuiCardHeader-subheader': {color: 'gray', fontSize: '11px'},
              '& .MuiCardHeader-title': {color: 'white'},
            }}
          />
          <CardContent sx={{ pt: 0 }} >
              
              <Grid container spacing={3}>
                

                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    helperText="Email Address"
                    name="email"
                    value={values.email}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        color: 'gray',
                        fontSize: '11px'
                      }                      
                    }}
                    variant="filled"
                    sx={{
                      '& .MuiFormHelperText-root': {
                        fontSize: '1.1rem',
                        color: 'white'                      
                      }
                    }}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    helperText="User Category"
                    name="category"
                    value={values.category}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        color: 'gray',
                        fontSize: '11px'
                      }  
                    }}
                    variant="filled"
                    sx={{
                      '& .MuiFormHelperText-root': {
                        fontSize: '1.1rem',
                        color: 'white'                      
                      }
                    }}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    helperText="Country"
                    name="country"
                    value={values.country}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        color: 'gray',
                        fontSize: '11px'
                      }  
                    }}
                    variant="filled"
                    sx={{
                      '& .MuiFormHelperText-root': {
                        fontSize: '1.1rem',
                        color: 'white'                      
                      }
                    }}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    helperText="User City"
                    name="city"
                    value={values.city}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        color: 'gray',
                        fontSize: '11px'
                      }  
                    }}
                    variant="filled"
                    sx={{
                      '& .MuiFormHelperText-root': {
                        fontSize: '1.1rem',
                        color: 'white'                      
                      }
                    }}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    helperText="Signatory name"
                    name="company"
                    value={values.signatory}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        color: 'gray',
                        fontSize: '11px'
                      }  
                    }}
                    variant="filled"
                    sx={{
                      '& .MuiFormHelperText-root': {
                        fontSize: '1.1rem',
                        color: 'white'                      
                      }
                    }}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    helperText="Date signed"
                    name="datesigned"
                    onChange={handleChange}
                    required
                    value={values.datesigned}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        color: 'gray',
                        fontSize: '11px'
                      }  
                    }}
                    variant="filled"
                    sx={{
                      '& .MuiFormHelperText-root': {
                        fontSize: '1.1rem',
                        color: 'white'                      
                      }
                    }}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextField
                    fullWidth
                    helperText="Account-number"
                    name="accountnumber"
                    value={values.account_number}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        color: 'gray',
                        fontSize: '11px'
                      }  
                    }}
                    variant="filled"
                    sx={{
                      '& .MuiFormHelperText-root': {
                        fontSize: '1.1rem',
                        color: 'white'                      
                      }
                    }}
                  />
                </Grid>

              </Grid>

            
          </CardContent>
          <Divider />
          <CardActions 
            sx={{ justifyContent: 'flex-end',
                '& .MuiButton-text' : {color: 'var(--main-color)'},
                '& .MuiButtonBase-root' : {border: '1px solid var(--main-color)'}, 
          }}>
            <Button             
              fullWidth 
              onClick={() => handleClickOpen(1)}>
              Update profile information
            </Button>
            <CustomDialog open={open} handleClose={handleClose} dialogType={dialogType} values={values}/>
          </CardActions>
        </Card>

        <Card>
          <CardHeader
            subheader="Click here to update your password. It is required at least 1 number and 1 special character (@,#,$,%,!,_,-)"
            title="Password Update"
            sx={{
              '& .MuiCardHeader-subheader': {color: 'gray', fontSize: '11px'},
              '& .MuiCardHeader-title': {color: 'white'},
            }}
          />

          <CardActions 
            sx={{ justifyContent: 'flex-end',
                '& .MuiButton-text' : {color: 'var(--main-color)'},
                '& .MuiButtonBase-root' : {border: '1px solid var(--main-color)'}, 
          }}>
            <Button             
              fullWidth 
              onClick={() => handleClickOpen(2)}>
              Update password
            </Button>
            <CustomDialog open={open} handleClose={handleClose} dialogType={dialogType} values={values}/>
          </CardActions>

        </Card>  
        {values.category === "Guest" && <FormRequestKeys />}
      </Stack> 

    </form>
     
  );
};